module.exports = __webpack_public_path__ + "static/media/bag-shop.994cadc6.svg";